/**
 * Loading component for Suspense boundaries
 * Displays themed loading UI while lazy-loaded components load
 */

import { useEffect, useState } from 'react';

export function LoadingSuspense() {
  const [dots, setDots] = useState('.');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '.' : prev + '.'));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="matrix-container p-8 max-w-md">
        {/* Matrix-themed loading */}
        <div className="text-center space-y-4">
          <div className="text-green-400 font-mono text-xl animate-pulse">
            [ LOADING{dots} ]
          </div>

          <div className="text-green-500 font-mono text-sm opacity-70">
            <div className="mb-2">Initializing system</div>
            <div className="flex justify-center space-x-1">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0s' }}></div>
              <div className="w-2 h-2 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-2 h-2 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
            </div>
          </div>

          {/* ASCII art loader */}
          <pre className="text-green-400 text-xs opacity-50 mt-4">
{`    ___
   /   \\
  | O O |
   \\___/
    |||
   /| |\\`}
          </pre>
        </div>

        {/* CRT scanline effect */}
        <div className="absolute inset-0 pointer-events-none scanlines opacity-20"></div>
      </div>
    </div>
  );
}

export default LoadingSuspense;
